import { LitElement, html, css} from "lit";

import {
  nlDateToIsoDate,
  createDateObj,
  makeNLDate
} from "./shared/clientside_sitehelpers";
import { normalize, openprops, buttons } from "./shared/openprops.css.js";



class MyCalendars extends LitElement {
  static get styles() {
    return css`
      ${normalize}
      ${openprops}
      ${buttons}
      .includedandbooking,
      extra-services,
      costs-onsite {
        width: 300px;
      }

      .includedandbooking,
      costs-onsite,
      extra-services {
        padding-top: 1em;
      }

      .inclusiveTitle {
        font-weight: 600;
      }

      .price {
        font-size: 2.5em;
        font-weight: 600;
        padding-right: 1em;
      }

      .discount {
        text-decoration: line-through;
        font-size: 70%;
        color: #bdbdbd;
      }

      date-input {
        --label-color: var(--primary-text-color);
        margin: 0 1em 1em 0;
      }

      .included {
        display: block;
      }

      .included,
      costs-onsite,
      extra-services {
        font-size: 0.9em;
      }

      #bookingbutton {
        background-color: var(--secondary-color);
        color: var(--green-0);
        margin-top: var(--size-3);
      }

      .booking {
        padding-top: 2em;
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 3em;
      }
    `;
  }

  renderi() {
   return html`clientside ${this.clientside}`;
  }

  render() {
    return html`
    ${this.clientside ? html`<date-input
      id="arrivalInput"
      label="Aankomst"
      @model-value-changed=${(e) =>
        e.detail.isTriggeredByUser &&
        this._setArrivalDepartureDates(e.detail.formPath[0].modelValue)}
      .validators=${[
        new this.IsDate("", { getMessage: () => "Kies een geldige datum" }),
        new this.IsDateDisabled(
          (day) =>
            this.availablearrivaldates.length > 0 &&
            this.availablearrivaldates.indexOf(this._makeISODate(day)) === -1
        ),
      ]}
    ></date-input>
    <date-input
      id="departureInput"
      label="Vertrek"
      @model-value-changed=${(e) =>
        e.detail.isTriggeredByUser && this._setPrice()}
      .validators=${[
        new this.IsDate("", { getMessage: () => "Kies een geldige datum" }),
        new this.IsDateDisabled(
          (day) =>
            this.departuredates.length > 0 &&
            this.departuredates.indexOf(this._makeISODate(day)) === -1
        ),
      ]}
    ></date-input>` : ``}
    <div class="includedandbooking">
              ${
                this.price
                  ? html`
                      <span class="included">
                        <span class="inclusiveTitle">Inclusief</span><br />
                        ${this.includedCosts.map(
                          (item, index) =>
                            html`
                              ${item.Description}
                              ${this._lastItem(index, this.includedCosts)}
                            `
                        )}
                      </span>
                    `
                  : ""
              }
            </div>
            <div class="includedandbooking">
              ${
                this.price
                  ? html`
                      <span class="price">
                        ${this.priceWithoutDiscount
                          ? html`
                              <span class="discount"
                                >€ ${this.priceWithoutDiscount}</span
                              >
                            `
                          : ""}€
                        ${this.price}
                      </span>
                      <br />
                      <lion-form @submit=${this._book} id="form">
                        <form @submit=${(ev) => ev.preventDefault()}>
                          <lion-input-stepper
                            id="personStepper"
                            max="${this.maxpersons}"
                            min="1"
                            .modelValue=${parseInt(this.persons, 10)}
                            name="persons"
                            @model-value-changed=${this._personsChanged}
                            ><label slot="label">Aantal personen</label>
                          </lion-input-stepper>
                          <button
                            id="bookingbutton"
                            @click="${this._book}"
                            >Naar boekings formulier</button
                          >
                        </form>
                      </lion-form>
                    `
                  : ""
              }
            </div>
            ${
              this.price
                ? html`
                    <costs-onsite
                      items="${JSON.stringify(this.additionalCosts)}"
                    ></costs-onsite>
                    <extra-services
                      items="${JSON.stringify(this.extraServicesCosts)}"
                    ></extra-services>
                  `
                : ""
            }
          </div>
   `;
  }

  static get properties() {
    return {
      arrivaldate: {
        type: String,
      },
      departuredate: {
        type: String,
      },
      departuredates: {
        type: Array,
      },
      availablearrivaldates: {
        type: Array,
      },
      housecode: {
        type: String,
      },
      price: {
        type: String,
      },
      additionalCosts: {
        type: Array,
      },
      includedCosts: {
        type: Array,
      },
      extraServicesCosts: {
        type: Array,
      },
      persons: {
        type: Number,
      },
      maxpersons: {
        type: Number,
      },
      clientside: {
        type: Boolean,
      }
    };
  }

  static get is() {
    return "my-calendars";
  }

  constructor() {
    super();
    this.departuredates = [];
    this.availablearrivaldates = [];
    this.additionalCosts = [];
    this.includedCosts = [];
    this.extraServicesCosts = [];
    this.persons = 1;
    this.clientside = false;
  }

  async firstUpdated() {
    const { IsDate, IsDateDisabled } = await import("@lion/ui/form-core.js");
    this.IsDate = IsDate;
    this.IsDateDisabled = IsDateDisabled; 
    await import("@lion/ui/form.js");
    await import("@lion/ui//define/lion-input-stepper.js");
    await import("./date-input.js");
   
    this.clientside = true;
    //get the arrivaldate and departuredate from location if possible
    const locationSearch = new URLSearchParams(location.search);

    this.arrivaldate = locationSearch.get("aankomst")
      ? createDateObj(nlDateToIsoDate(locationSearch.get("aankomst")))
      : createDateObj(this.arrivaldate);
    this.departuredate = locationSearch.get("vertrek")
      ? createDateObj(nlDateToIsoDate(locationSearch.get("vertrek")))
      :createDateObj(this.departuredate)
    this._setArrivalDepartureDates(this.arrivaldate);
    this._setPrice(this.arrivaldate, this.departuredate);
    this._setArrivalDates(this.housecode);
  }

  updated() {
    if(this.shadowRoot.querySelector("#arrivalInput") && this.shadowRoot.querySelector("#departureInput")) {
      this.shadowRoot.querySelector("#arrivalInput").modelValue = this.arrivaldate;
      this.shadowRoot.querySelector("#departureInput").modelValue = this.departuredate;
    }
  }

  _getArrivalDate() {
    return this.shadowRoot.querySelector("#arrivalInput").modelValue;
  }

  _getDepartureDate() {
    return this.shadowRoot.querySelector("#departureInput").modelValue;
  }

  _lastItem(index, items) {
    return index + 1 < items.length ? ", " : "";
  }

  _personsChanged() {
    this.persons = this.shadowRoot.querySelector("#personStepper").modelValue;
    this._calculatePricePersons();
  }

  _setPrice(arrivaldate, departuredate) {

    if (!arrivaldate || !departuredate) {
      // date is not passed in function, get from calendars
      arrivaldate = this._getArrivalDate();
      departuredate = this._getDepartureDate();
   
      // make sure to set this because here because we may have come from departure calendar click, the next code will change the dom and somehow the departuredate is not synced yet and will be reverted
      this.departuredate = departuredate;
    }

    fetch(
      `/api/houses/availability/${this.housecode}/${this._makeISODate(
        arrivaldate
      )}/${this._makeISODate(departuredate)}`
    )
      .then((res) => res.json())
      .then((data) => {
        this.ajaxResponse = data;
        this.guestsIncluded = data.GuestsIncluded;
        this.pricePerGroup = data.PerGroup;
        this.groupPriceWithoutDiscount = data.PerGroupPriceExclDiscount;
        this.pricePerGuest = data.PerGuest;
        this._retrieveCostsOnSiteAndIncluded(this._makeISODate(arrivaldate));
        this._calculatePricePersons();
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.log(e);
      });

  }

  _retrieveCostsOnSiteAndIncluded(date) {
    const url = `/api/houses/costsonsite/${this.housecode}/${date}`;

    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        const includedArray = [
          {
            Description: "Boekingskosten",
            Category: "Included",
            Value: "Inclusief",
            From: "2017-01-30",
            Until: "9999-12-31",
          },
          {
            Description: "Schadeverzekering",
            Category: "Included",
            Value: "Inclusief",
            From: "2017-01-30",
            Until: "9999-12-31",
          },
        ];
        const additionalArray = [];
        const servicesArray = [];
        // this.costsonsite = req.response;
        if (data.entity && data.entity.length > 0) {
          data.entity.forEach((element) => {
            // eslint-disable-next-line default-case
            switch (element.Category) {
              case "Included":
                includedArray.push(element);
                break;
              case "AdditionalCosts":
                additionalArray.push(element);
                break;
              case "ServiceOnSite":
                servicesArray.push(element);
                break;
            }
          });
        }
        this.additionalCosts = additionalArray;
        this.includedCosts = includedArray;
        this.extraServicesCosts = servicesArray;
      })
      // eslint-disable-next-line no-console
      .catch((e) => console.log(e));
  }

  _calculatePricePersons() {
    const extraGuests =
      this.persons - this.guestsIncluded > 0
        ? this.persons - this.guestsIncluded
        : 0;
    this.price = Math.ceil(
      parseInt(this.pricePerGroup, 10) +
        parseInt(this.pricePerGuest, 10) * extraGuests
    );
    const discountPrice = Math.ceil(
      parseInt(this.groupPriceWithoutDiscount, 10) +
        parseInt(this.pricePerGuest, 10) * extraGuests
    );
    this.priceWithoutDiscount =
      discountPrice > this.price ? discountPrice : false;
  }

  _book() {
    // set the params to the dates and amount of people user has selected
    const location = new URL(window.location);
    location.searchParams.set("personen", this.persons);
    location.searchParams.set("aankomst", makeNLDate(this._getArrivalDate()));
    location.searchParams.set("vertrek", makeNLDate(this._getDepartureDate()));

    // now navigate to booking page
    const url = `${
      location.pathname
    }boeking?${location.searchParams.toString()}`;
    window.location.href= url;
  }

  _makeISODate(dateObj) {
    return `${dateObj.getFullYear()}-${(dateObj.getMonth() + 1).toString().padStart(2, "0")}-${dateObj.getDate().toString().padStart(2, "0")}`;
  }

  _setArrivalDepartureDates(arrivalDate) {
    this.arrivaldate = arrivalDate;

    fetch(
      `/api/houses/departuredates/${this.housecode}/${this._makeISODate(
        this.arrivaldate
      )}`
    )
      .then((res) => res.json())
      .then((data) => {
        this.departuredates = data.dates;
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.log(e);
      });
  }

  _setArrivalDates(housecode) {
    // get month and year from startdate
    // TODO extract into method as it also needs to be called when the calendar month is navigated/changed
    fetch(
      `/api/houses/arrivaldates/${housecode}/${this.arrivaldate.toLocaleDateString(
        "nl-NL",
        {
          year: "numeric",
          month: "2-digit",
        }
      )}`
    )
      .then((res) => res.json())
      .then((data) => {
        this.availablearrivaldates = data.dates;
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.log(e);
      });
  }
  
}
customElements.define(MyCalendars.is, MyCalendars);
